/* JAK'S DIESEL — shared interactions */
(function(){
  // ---- Mobile nav toggle ----
  window.toggleMobileNav = function(){
    document.body.classList.toggle('mnav-open');
  };

  // ---- Live search autocomplete (Shopify predictive search) ----
  function acEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  window.bindSearch = function(inputRef, panelRef){
    var input = typeof inputRef === 'string' ? document.getElementById(inputRef) : inputRef;
    var panel = typeof panelRef === 'string' ? document.getElementById(panelRef) : panelRef;
    if(!input || !panel || input.dataset.acBound) return;
    input.dataset.acBound = '1';
    var timer;
    function close(){ panel.classList.remove('open'); }
    function render(q){
      q = (q || '').trim();
      if(q.length < 2){ close(); return; }
      var all = '<a class="ac-row ac-all" href="/search?q=' + encodeURIComponent(q) + '&type=product"><div class="ac-main"><div class="t" style="color:var(--mil)">See all results for &ldquo;' + acEsc(q) + '&rdquo; &rarr;</div></div></a>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          var ps = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if(!ps.length){
            panel.innerHTML = '<div class="ac-group"><div class="ac-row"><div class="ac-main"><div class="t">No instant match — our specialists cross it for you.</div><div class="s">Call or text (720) 445-6249</div></div></div>' + all + '</div>';
          } else {
            panel.innerHTML = '<div class="ac-group"><div class="ac-label">Matching Parts</div>' + ps.map(function(p){
              var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
              var thumb = img ? '<div class="ac-thumb"><img src="' + img + '" alt="" loading="lazy"></div>' : '<div class="ac-thumb"></div>';
              var sub = p.product_type ? '<div class="s">' + acEsc(p.product_type) + '</div>' : '';
              var title = (p.title || '').split('|')[0].trim();
              return '<a class="ac-row" href="' + p.url + '">' + thumb + '<div class="ac-main"><div class="t">' + acEsc(title) + '</div>' + sub + '</div></a>';
            }).join('') + all + '</div>';
          }
          panel.classList.add('open');
        })
        .catch(close);
    }
    input.addEventListener('input', function(e){ clearTimeout(timer); timer = setTimeout(function(){ render(e.target.value); }, 180); });
    input.addEventListener('focus', function(e){ if((e.target.value || '').trim().length >= 2) render(e.target.value); });
    input.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
    document.addEventListener('click', function(e){ if(!panel.contains(e.target) && e.target !== input) close(); });
  };
  // Auto-wire every search box that has an .ac results panel (header, hero, 404)
  function autoBindSearch(){
    document.querySelectorAll('.ac').forEach(function(panel){
      var c = panel.closest('.search, .hero-search, .searchbox');
      var inp = c && c.querySelector('input[type="search"], input[type="text"]');
      if(inp){ window.bindSearch(inp, panel); }
    });
  }
  if(document.readyState !== 'loading') autoBindSearch();
  else document.addEventListener('DOMContentLoaded', autoBindSearch);

  // ---- Cross reference tool (demo) ----
  const XREF = {
    '2454324':  {t:'CAT C15 ACERT Cylinder Head — Loaded',  jak:'JD-CH-C15A', oem:'CAT 2454324', stock:'In Stock — Ships Today', thumb:'assets/badge-cat.png'},
    '4962731':  {t:'Cummins ISX15 Cylinder Head Assembly',  jak:'JD-CH-ISX15', oem:'Cummins 4962731', stock:'In Stock — Ships Today', thumb:'assets/badge-cummins.png'},
    '23537192': {t:'Detroit Series 60 Inframe Overhaul Kit', jak:'JD-KIT-S60', oem:'Detroit 23537192', stock:'In Stock — Ships Today', thumb:'assets/badge-detroit.png'},
    '21404452': {t:'Mack MP8 Inframe Rebuild Kit',          jak:'JD-KIT-MP8', oem:'Mack 21404452', stock:'2–3 Day Lead', thumb:'assets/badge-mackvolvo.png'},
    '1866428':  {t:'Paccar MX-13 Head Bolt Set',            jak:'JD-HB-MX13', oem:'Paccar 1866428', stock:'In Stock — Ships Today', thumb:'assets/badge-paccar.png'}
  };
  window.runCrossRef = function(){
    const input = document.getElementById('xrInput');
    const out = document.getElementById('xrResult');
    if(!input||!out) return;
    const raw = input.value.replace(/[^0-9a-z]/gi,'').toUpperCase();
    let match = XREF[raw];
    if(!match){
      // fuzzy: take any digits subset
      const k = Object.keys(XREF).find(k=>raw && (k.includes(raw)||raw.includes(k)));
      if(k) match = XREF[k];
    }
    if(!match){
      out.innerHTML = '<div class="xr-match"><div class="xm-thumb"></div><div class="xm-main"><div class="mt">No instant catalog match found</div>'+
        '<div class="ms">A diesel specialist will cross this number by hand — <b>call or text (720) 445-6249</b></div></div></div>'+
        '<div class="xr-flag"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 8v4M12 16h.01"/><circle cx="12" cy="12" r="9"/></svg> We cross-reference 1M+ OEM, dealer &amp; competitor numbers daily.</div>';
    } else {
      out.innerHTML = '<div class="xr-match"><div class="xm-thumb"><img src="'+match.thumb+'" alt=""></div>'+
        '<div class="xm-main"><div class="mt">'+match.t+'</div>'+
        '<div class="ms">Matches <b>'+match.oem+'</b> → JAK\'S #'+match.jak+'</div></div>'+
        '<a class="btn btn-green" href="product.html" style="margin-left:auto">View Part</a></div>'+
        '<div class="xr-flag"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> '+match.stock+' · Warranty Backed</div>';
    }
    out.classList.add('show');
  };
  window.xrExample = function(v){
    const input = document.getElementById('xrInput');
    if(input){ input.value = v; window.runCrossRef(); }
  };

  // ---- Product page: qty + tabs ----
  window.qtyStep = function(d){
    const el = document.getElementById('qty');
    if(!el) return;
    let v = parseInt(el.value||'1',10) + d;
    if(v < 1) v = 1;
    el.value = v;
  };
  window.showTab = function(id, btn){
    document.querySelectorAll('.tab-panel').forEach(p=>p.classList.remove('active'));
    document.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('active'));
    const panel = document.getElementById(id);
    if(panel) panel.classList.add('active');
    if(btn) btn.classList.add('active');
  };
  window.pickThumb = function(src, el){
    const main = document.getElementById('pdpMain');
    if(main) main.style.setProperty('--n', src);
    document.querySelectorAll('.pdp-thumb').forEach(t=>t.classList.remove('active'));
    if(el) el.classList.add('active');
  };

  // ---- Custom dropdowns (replace native <select.js-cselect>) ----
  function place(panel, trigger){
    const r = trigger.getBoundingClientRect();
    const pw = Math.max(r.width, 200);
    panel.style.minWidth = pw + 'px';
    panel.style.left = Math.max(8, Math.min(r.left, window.innerWidth - pw - 8)) + 'px';
    panel.style.top  = (r.bottom + 6) + 'px';
  }
  function closeAll(){
    document.querySelectorAll('.cs-panel.open').forEach(p=>p.classList.remove('open'));
    document.querySelectorAll('.cselect.open').forEach(w=>w.classList.remove('open'));
  }
  function enhanceSelects(){
    document.querySelectorAll('select.js-cselect').forEach(sel=>{
      if(sel.dataset.enhanced) return;
      sel.dataset.enhanced = '1';
      const wrap = document.createElement('div');
      wrap.className = 'cselect';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'cs-trigger';
      const label = document.createElement('span');
      label.className = 'cs-label';
      trigger.appendChild(label);
      trigger.insertAdjacentHTML('beforeend','<span class="cs-caret"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M6 9l6 6 6-6"/></svg></span>');
      const panel = document.createElement('div');
      panel.className = 'cs-panel';
      [...sel.options].forEach((o,i)=>{
        const row = document.createElement('div');
        row.className = 'cs-opt' + (o.selected ? ' sel' : '');
        row.innerHTML = '<span>'+o.textContent+'</span><span class="ck"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></span>';
        row.addEventListener('click', ()=>{
          sel.selectedIndex = i;
          label.textContent = o.textContent;
          panel.querySelectorAll('.cs-opt').forEach(x=>x.classList.remove('sel'));
          row.classList.add('sel');
          closeAll();
          sel.dispatchEvent(new Event('change',{bubbles:true}));
        });
        panel.appendChild(row);
      });
      label.textContent = sel.options[sel.selectedIndex].textContent;
      trigger.addEventListener('click', e=>{
        e.stopPropagation();
        const isOpen = wrap.classList.contains('open');
        closeAll();
        if(!isOpen){ wrap.classList.add('open'); panel.classList.add('open'); place(panel, trigger); }
      });
      wrap.appendChild(trigger);
      document.body.appendChild(panel);
      sel.style.display = 'none';
      sel.parentNode.insertBefore(wrap, sel);
    });
    document.addEventListener('click', closeAll);
    window.addEventListener('resize', closeAll);
    window.addEventListener('scroll', closeAll, true);
  }
  window.enhanceSelects = enhanceSelects;
  if(document.readyState !== 'loading') enhanceSelects();
  else document.addEventListener('DOMContentLoaded', enhanceSelects);
})();
